import React, { useEffect, useState } from 'react'
import Logo from "../../Assets/Images/logo.png"
import { Input, notification } from 'antd'
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import config, { axiosInstance } from '../Config';
import secureLocalStorage from 'react-secure-storage';
import swal from 'sweetalert';
import AccountContainer from './AccountContainer';

const ResetPassword = () => {

    const navigate = useNavigate();

    const [show_password, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [show_password2, setShowPassword2] = useState(false);
    const [confirm_password, setConfirmPassword] = useState("");

    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        const credential = secureLocalStorage.getItem('credentials')
        try {
            if (credential) {
                if (('id' in credential) && ('name' in credential) && ('email' in credential)) {
                    navigate(`${config.appUrl}`);
                }
            }
        } catch (error) {

        }
    }, []);

    const onHandleFor = async (e) => {
        e.preventDefault();
        try {
            if (confirm_password == password) {
                setLoading(true);
                const user_info = secureLocalStorage.getItem("temp_data")

                const formData = new FormData()
                formData.append("email", user_info.email)
                formData.append("password", password)
                formData.append("type", 0)

                const response = await axiosInstance.post(`/reset-password`, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                })

                if (response.data.success == true) {

                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-check text-success"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Password Reset Successfully.</div>
                            </div>
                        ),
                        description: "",
                    });

                    secureLocalStorage.removeItem("temp_data")

                    setTimeout(() => {
                        navigate(`${config.appUrl}login`)
                    }, 1000)
                }
                else {
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-warning text-danger"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Opp! Something went wrong.</div>
                            </div>
                        ),
                        description: "",
                    });
                }
                setLoading(false);
            }
            else {
                notification.open({
                    message: (
                        <div className="d-flex">
                            <div className="pr-10">
                                <i
                                    className="icon-warning text-danger"
                                    style={{ fontSize: "20px" }}
                                ></i>
                            </div>
                            <div>Confirm Password is not same</div>
                        </div>
                    ),
                    description: "Please Enter Correct Password",
                });
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
            swal("", "Something went wrong!", "error")
        }
    };

    return (
        <div>
            {isLoading && (<Loader />)}

            <AccountContainer>
                <form onSubmit={onHandleFor}>
                    <div className="ps-form__content px-5 pt-5">
                        <div className='text-center  '>
                            <img src={Logo} alt='No Logo' className='img-fluid w-50 mb-2' />
                        </div>
                        <h5 className=" fs-2 text-center">Reset Your Password</h5>

                        <div className="form-group form-forgot mt-5 ">
                            <label htmlFor="" className='text-uppercase'>create password</label>
                            <div className="position-relative">
                                <Input
                                    className="form-control form-field"
                                    type={show_password ? "text" : "password"}
                                    placeholder="Password..."
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                    }}
                                />
                                <div className="bd-eye-open">
                                    <a onClick={() => setShowPassword(!show_password)}>
                                        <i
                                            className={
                                                show_password ? "icon-eye-crossed" : "icon-eye"
                                            }
                                        ></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="form-group form-forgot ">
                            <label htmlFor="" className='text-uppercase'>Confirm password</label>
                            <div className="position-relative">
                                <Input
                                    className="form-control form-field"
                                    type={show_password2 ? "text" : "password"}
                                    placeholder="Password..."
                                    value={confirm_password}
                                    onChange={(e) => {
                                        setConfirmPassword(e.target.value)
                                    }}
                                />
                                <div className="bd-eye-open">
                                    <a onClick={() => setShowPassword2(!show_password2)}>
                                        <i
                                            className={
                                                show_password2 ? "icon-eye-crossed" : "icon-eye"
                                            }
                                        ></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="form-group mt-5 ">
                            <button
                                type="submit"
                                className="ps-btn ps-btn--fullwidth btn-green color-white"
                            >
                                Reset Password
                            </button>
                        </div>
                    </div>
                </form>

            </AccountContainer>
        </div>
    )
}

export default ResetPassword